/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ErrorLogDto model module.
 * @module model/ErrorLogDto
 * @version v0
 */
class ErrorLogDto {
    /**
     * Constructs a new <code>ErrorLogDto</code>.
     * @alias module:model/ErrorLogDto
     */
    constructor() { 
        
        ErrorLogDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ErrorLogDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ErrorLogDto} obj Optional instance to populate.
     * @return {module:model/ErrorLogDto} The populated <code>ErrorLogDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ErrorLogDto();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
            if (data.hasOwnProperty('errorMessage')) {
                obj['errorMessage'] = ApiClient.convertToType(data['errorMessage'], 'String');
            }
            if (data.hasOwnProperty('stackTrace')) {
                obj['stackTrace'] = ApiClient.convertToType(data['stackTrace'], 'String');
            }
            if (data.hasOwnProperty('errorType')) {
                obj['errorType'] = ApiClient.convertToType(data['errorType'], 'String');
            }
            if (data.hasOwnProperty('errorSource')) {
                obj['errorSource'] = ApiClient.convertToType(data['errorSource'], 'String');
            }
            if (data.hasOwnProperty('httpMethod')) {
                obj['httpMethod'] = ApiClient.convertToType(data['httpMethod'], 'String');
            }
            if (data.hasOwnProperty('requestUrl')) {
                obj['requestUrl'] = ApiClient.convertToType(data['requestUrl'], 'String');
            }
            if (data.hasOwnProperty('httpStatusCode')) {
                obj['httpStatusCode'] = ApiClient.convertToType(data['httpStatusCode'], 'Number');
            }
            if (data.hasOwnProperty('userAgent')) {
                obj['userAgent'] = ApiClient.convertToType(data['userAgent'], 'String');
            }
            if (data.hasOwnProperty('ipAddress')) {
                obj['ipAddress'] = ApiClient.convertToType(data['ipAddress'], 'String');
            }
            if (data.hasOwnProperty('additionalInfo')) {
                obj['additionalInfo'] = ApiClient.convertToType(data['additionalInfo'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ErrorLogDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ErrorLogDto</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['errorMessage'] && !(typeof data['errorMessage'] === 'string' || data['errorMessage'] instanceof String)) {
            throw new Error("Expected the field `errorMessage` to be a primitive type in the JSON string but got " + data['errorMessage']);
        }
        // ensure the json data is a string
        if (data['stackTrace'] && !(typeof data['stackTrace'] === 'string' || data['stackTrace'] instanceof String)) {
            throw new Error("Expected the field `stackTrace` to be a primitive type in the JSON string but got " + data['stackTrace']);
        }
        // ensure the json data is a string
        if (data['errorType'] && !(typeof data['errorType'] === 'string' || data['errorType'] instanceof String)) {
            throw new Error("Expected the field `errorType` to be a primitive type in the JSON string but got " + data['errorType']);
        }
        // ensure the json data is a string
        if (data['errorSource'] && !(typeof data['errorSource'] === 'string' || data['errorSource'] instanceof String)) {
            throw new Error("Expected the field `errorSource` to be a primitive type in the JSON string but got " + data['errorSource']);
        }
        // ensure the json data is a string
        if (data['httpMethod'] && !(typeof data['httpMethod'] === 'string' || data['httpMethod'] instanceof String)) {
            throw new Error("Expected the field `httpMethod` to be a primitive type in the JSON string but got " + data['httpMethod']);
        }
        // ensure the json data is a string
        if (data['requestUrl'] && !(typeof data['requestUrl'] === 'string' || data['requestUrl'] instanceof String)) {
            throw new Error("Expected the field `requestUrl` to be a primitive type in the JSON string but got " + data['requestUrl']);
        }
        // ensure the json data is a string
        if (data['userAgent'] && !(typeof data['userAgent'] === 'string' || data['userAgent'] instanceof String)) {
            throw new Error("Expected the field `userAgent` to be a primitive type in the JSON string but got " + data['userAgent']);
        }
        // ensure the json data is a string
        if (data['ipAddress'] && !(typeof data['ipAddress'] === 'string' || data['ipAddress'] instanceof String)) {
            throw new Error("Expected the field `ipAddress` to be a primitive type in the JSON string but got " + data['ipAddress']);
        }
        // ensure the json data is a string
        if (data['additionalInfo'] && !(typeof data['additionalInfo'] === 'string' || data['additionalInfo'] instanceof String)) {
            throw new Error("Expected the field `additionalInfo` to be a primitive type in the JSON string but got " + data['additionalInfo']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
ErrorLogDto.prototype['id'] = undefined;

/**
 * @member {Number} userId
 */
ErrorLogDto.prototype['userId'] = undefined;

/**
 * @member {String} errorMessage
 */
ErrorLogDto.prototype['errorMessage'] = undefined;

/**
 * @member {String} stackTrace
 */
ErrorLogDto.prototype['stackTrace'] = undefined;

/**
 * @member {String} errorType
 */
ErrorLogDto.prototype['errorType'] = undefined;

/**
 * @member {String} errorSource
 */
ErrorLogDto.prototype['errorSource'] = undefined;

/**
 * @member {String} httpMethod
 */
ErrorLogDto.prototype['httpMethod'] = undefined;

/**
 * @member {String} requestUrl
 */
ErrorLogDto.prototype['requestUrl'] = undefined;

/**
 * @member {Number} httpStatusCode
 */
ErrorLogDto.prototype['httpStatusCode'] = undefined;

/**
 * @member {String} userAgent
 */
ErrorLogDto.prototype['userAgent'] = undefined;

/**
 * @member {String} ipAddress
 */
ErrorLogDto.prototype['ipAddress'] = undefined;

/**
 * @member {String} additionalInfo
 */
ErrorLogDto.prototype['additionalInfo'] = undefined;

/**
 * @member {Date} createdAt
 */
ErrorLogDto.prototype['createdAt'] = undefined;






export default ErrorLogDto;

